import { createContext, useContext, useState } from 'react';

const LanguageContext = createContext(null);

const dictionaries = {
    uz: {
        dashboard: 'Boshqaruv paneli', profile: 'Profil', logout: 'Chiqish', light: 'Yorug‘ rejim', dark: 'Tungi rejim',
        exams: 'Imtihonlar', myExams: 'Mening imtihonlarim', questions: 'Savollar', attempts: 'Natijalarim',
        create: 'Yaratish', admin: 'Administrator', superadmin: 'Bosh administrator', teacher: 'O‘qituvchi', editor: 'Savol muharriri', student: 'Talaba'
    },
    en: {
        dashboard: 'Dashboard', profile: 'Profile', logout: 'Logout', light: 'Light Mode', dark: 'Dark Mode',
        exams: 'Exams', myExams: 'My Exams', questions: 'Questions', attempts: 'My Attempts',
        create: 'Create', admin: 'Admin', superadmin: 'Superadmin', teacher: 'Teacher', editor: 'Question Editor', student: 'Student'
    }
};

export function LanguageProvider({ children }) {
    const [language, setLanguage] = useState(localStorage.getItem('language') || 'uz');
    const toggle = () => setLanguage((current) => {
        const next = current === 'uz' ? 'en' : 'uz';
        localStorage.setItem('language', next);
        return next;
    });
    const t = (key) => dictionaries[language]?.[key] || dictionaries.en[key] || key;
    return <LanguageContext.Provider value={{ language, toggle, t }}>{children}</LanguageContext.Provider>;
}

export const useLanguage = () => useContext(LanguageContext);
